/**
 * @fileoverview Tailwind class birleştirme yardımcısı.
 * clsx → koşullu class'ları düzleştirir
 * twMerge → çakışan Tailwind class'larını doğru öncelikle birleştirir
 *
 * @example
 * cn('px-4 py-2', isActive && 'bg-gold-base', props.className)
 */

import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * @param {...(string|undefined|null|false|Record<string,boolean>)} inputs
 * @returns {string}
 */
export const cn = (...inputs) => twMerge(clsx(inputs))
